import React, { useEffect, useState } from 'react';
import PDItemCardLoader from '../../../../components/PDItemCardLoader';
import { useSelector, useSSRSelector } from 'src/redux';
import { useGetDeviceType } from 'src/hooks/useGetDeviceType';
import { Card } from '@/components/DesignSystem/Card';
import { returnCommonConfigData } from '@/utils/returnCommonConfigData';
import { ProductCardWidget1 } from '@/components/DesignSystem/ProductItemWidget';
import { ProductCard } from 'src/components/DesignSystem/Widgets2.0/ProductCard';
import { useWidgetDndContextData } from 'src/context/WidgetDndContext';
import { getCartWrapperConfigs } from 'src/components/DesignSystem/Widgets2.0/ProductCard/utils';
import { useRouter } from 'next/router';
import { getRoute, PATH } from 'src/utils/routes';
import { NEW_SUBSCRIPTIONS_STATUS } from 'src/constants/subscription';
import { getProductPathFromUrl } from 'src/utils/productUtils';

export function SuggestedProducts() {
  const router = useRouter();
  const [availableSuggestions, setAvailableSuggestions] = useState([]);
  const { isMobile } = useGetDeviceType();

  const {
    widgetContextState: { globalStyle },
  } = useWidgetDndContextData();
  const { infoList, isEnabled: isProductCardEnabled } = globalStyle?.productCard || {
    infoList: [],
    isEnabled: false,
  };
  const showCustomProductCard = isProductCardEnabled && infoList?.length ? true : false;

  const { loader, similar_suggestions, suggestions, theme, category } = useSelector(
    (state: any) => {
      const similar_suggestions = state.catalogReducer.sharePDP.similar_suggestions;
      return {
        loader: state.commonReducer.loader,
        suggestions: state.catalogReducer.sharePDP.suggestions,
        similar_suggestions,
        theme: state.storeReducer.store.theme,
        category: similar_suggestions
          ? state.catalogReducer?.sharePDP?.suggestions?.[0]?.category
          : state.catalogReducer?.categories?.[0],
      };
    }
  );

  const { storeInfo } = useSSRSelector((state) => ({
    storeInfo: state.storeReducer.store,
  }));

  useEffect(() => {
    if (suggestions?.length) {
      setAvailableSuggestions(suggestions.filter((item) => !!item.available));
    }
  }, [suggestions]);

  const goToHomePage = () => {
    if (
      storeInfo?.new_subscription_status === NEW_SUBSCRIPTIONS_STATUS.INACTIVE &&
      !storeInfo.premium
    ) {
      router.push(getRoute(PATH.PRODUCT, storeInfo.store_info.domain));
    } else {
      router.push(
        getRoute(`${PATH.SHOP}?cid=${category.id}`, storeInfo.store_info.domain)
      );
    }
  };

  const onSuggestiveItemTap = (item) => {
    // window.scrollTo({ left: 0, top: 0 });
    const link = getRoute(
      getProductPathFromUrl(item?.link, false),
      storeInfo.store_info.domain
    );
    // router.replace(link);
    window.location.href = link;
  };

  // different card based on whether custom website is enabled or not
  const conditionalCardRender = (item, idx) => {
    if (showCustomProductCard) {
      const layoutElement = infoList?.find((item) => item.type === 'layout');
      const cardWrapperConfigs = getCartWrapperConfigs(layoutElement?.config);
      return (
        <ProductCard
          onItemClick={onSuggestiveItemTap}
          key={item.id}
          productData={item}
          itemIndex={idx}
          configs={{
            cardWrapperConfigs,
            isMobile,
            dimensions: { cardHeight: 200, cardWidth: 200 },
          }}
        />
      );
    }
    return theme?.custom_theme_flag ? (
      <ProductCardWidget1
        isPdp={true}
        key={item.id}
        data={item}
        onItemClick={() => onSuggestiveItemTap(item)}
        showButton={false}
        categoryConfig={returnCommonConfigData({
          activeCategoryConfig: { animation: 'pop' },
        })}
      />
    ) : (
      <Card
        isPdp={true}
        key={item.id}
        data={item}
        onItemClick={() => onSuggestiveItemTap(item)}
        showButton={true}
      />
    );
  };

  return (
    <>
      <div className="suggestion__box tw-gap-[20px]">
        {loader && (
          <>
            <PDItemCardLoader />
            <PDItemCardLoader />
            <PDItemCardLoader />
          </>
        )}
      </div>
      {!!availableSuggestions?.length && (
        <section className="pdp__main--suggestion">
          <h3>{similar_suggestions ? 'More in category' : 'Other Products in Store'}</h3>
          <div className="suggestion__box tw-gap-[20px]">
            <div className="dn-ns db" />
            {!loader && (
              <>
                {availableSuggestions.map((item, idx) => {
                  return conditionalCardRender(item, idx);
                })}
                <div className="suggestion__box--viewall">
                  <span
                    onClick={goToHomePage}
                    style={{
                      cursor: 'pointer',
                      border: `1px solid ${storeInfo?.theme?.colors?.primary_color}`,
                      backgroundColor: storeInfo?.theme?.colors?.primary_color
                        ? storeInfo?.theme?.colors?.primary_color
                        : '#ea5151',
                    }}
                  >
                    View all
                  </span>
                </div>
              </>
            )}
          </div>
        </section>
      )}
    </>
  );
}
